const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { FrontendUserState as State } from '@/features/auth/model/state-route';
import { routeForState } from '@/features/auth/model/state-route';
export const Route = createFileRoute('/_app')({
  // The single place the frontend switches on the backend-computed `frontendUserState`.
  beforeLoad: async ({
    context,
    location
  }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }
    const {
      frontendUserState
    } = await context.ensureProfile();
    if (frontendUserState === State.active) {
      return;
    }
    if (frontendUserState === State.unauthorized) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }
    const target = routeForState(frontendUserState);
    // `routeForState` returns a screen for every non-Active state (and
    // /server-error for null); fall back to /server-error defensively.
    throw redirect({
      to: target ?? '/server-error'
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});